<template>
  <md-dialog :md-active.sync="showEdiAjustOrig" :md-click-outside-to-close="false" class="custom-dialog">
    <md-dialog-title class="dialog-header">
      <span class="header-title">{{ f_titulo() }}</span>
    </md-dialog-title>
    
    <md-dialog-content class="dialog-content">
      <!-- Campos de búsqueda (solo para adición) -->
      <div v-if="dataEdit.cuenta == null" class="search-fields">
        <div class="form-field">
          <label class="field-label">{{ labels.criterio }}</label>
          <div class="search-inputs">
            <md-field class="custom-field">
              <md-input v-model="critCuenta" :placeholder="labels.criterioCuenta"></md-input>
            </md-field>
            <md-field class="custom-field">
              <md-input v-model="critDescripcion" :placeholder="labels.criterioDescripcion"></md-input>
            </md-field>
          </div>
        </div>
      </div>

      <!-- Campo de cuenta -->
      <div class="form-fields">
        <div class="form-field">
          <label class="field-label">{{ labels.cuenta }}</label>
          <div v-if="dataEdit.cuenta" class="display-value">
            {{ dataEdit.cuenta }}
          </div>
          <div v-else class="multi-select-container">
            <div class="selection-count" v-if="listadoCuentasOrig.length > 0">
              {{ labels.seleccionadas }}: {{ listadoCuentasOrig.length }}
            </div>
            <div class="select-all-container" v-if="listCuentasSelMul.length > 0">
              <md-checkbox v-model="selectAllOrig" @change="toggleSelectAllOrig">
                {{ labels.selectAll }}
              </md-checkbox>
            </div>
            <div class="accounts-table-container" v-if="listCuentasSelMul.length > 0">
              <table class="accounts-table">
                <thead>
                  <tr>
                    <th class="checkbox-column"></th>
                    <th class="account-column">{{ labels.cuenta }}</th>
                    <th class="desc-column">{{ labels.description }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(cuenta,idx) in listCuentasSelMul" :key="idx+'-'+cuenta.id">
                    <td class="checkbox-column">
                      <md-checkbox v-model="cuenta._selected" @change="onAccountChange(cuenta)" />
                    </td>
                    <td class="account-column">{{ cuenta.cuenta }}</td>
                    <td class="desc-column">{{ cuenta.descripcion }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else class="no-results">
              {{ labels.noAccountsFound }}
            </div>
          </div>
        </div>

        <!-- Campos adicionales (solo para edición) -->
        <template v-if="dataEdit.cuenta">
          <div class="form-field">
            <label class="field-label">{{ labels.description }}</label>
            <div class="display-value">
              {{ dataEdit.descripcion }}
            </div>
          </div>

          <div class="form-field">
            <label class="field-label">{{ labels.valor }}</label>
            <md-field class="custom-field">
              <md-input v-model="dataEdit.valor"></md-input>
            </md-field>
          </div>

          <div class="form-field">
            <label class="field-label">{{ labels.funcional }}</label>
            <md-field class="custom-field">
              <md-input v-model="dataEdit.funcional"></md-input>
            </md-field>
          </div>

          <div class="form-field">
            <label class="field-label">{{ labels.alterna }}</label>
            <md-field class="custom-field">
              <md-input v-model="dataEdit.alterna"></md-input>
            </md-field>
          </div>
        </template>
      </div>
    </md-dialog-content>

    <md-dialog-actions class="dialog-actions">
      <md-button class="md-raised cancel-btn" @click="closeModal" :disabled="isSaving">
        {{ labels.close }}
      </md-button>
      <md-button class="md-raised md-primary save-btn" @click="guardaAjuste" :disabled="isSaving">
        {{ isSaving ? labels.saving : labels.save }}
      </md-button>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
import AjustesConsol from '../../services/AjustesConsol'

export default {
  name: "EditAjustesOrigen",
  props: ['showEdiAjustOrig', 'dataEdit', 'listCuentas', 'listCuentasSelMul', 'codReporte', 'idCompania', 'vigencia', 'secuencia', 'tipo', 'tipo_ajuste'],
  data: () => ({
    critCuenta: "",
    critDescripcion: "",
    listadoCuentasOrig: [],
    selectAllOrig: false,
    isSaving: false,
  }),
  computed: {
    labels() {
      if (this.$store.state._language == "es-ES") {
        return {
          criterio: "Criterio de búsqueda",
          criterioCuenta: "Buscar por cuenta...",
          criterioDescripcion: "Buscar por descripción...",
          title: "Editar ajuste",
          save: "Guardar",
          saving: "Guardando...",
          close: "Cerrar",
          cuenta: "Cuenta",
          description: "Descripción",
          valor: "Valor",
          funcional: "Funcional",
          alterna: "Alterna",
          seleccionadas: "Cuentas seleccionadas",
          selectAll: "Seleccionar todas",
          noAccountsFound: "No se encontraron cuentas"
        }
      } else {
        return {
          criterio: "Search criteria",
          criterioCuenta: "Search by account...",
          criterioDescripcion: "Search by description...",
          title: "Edit setting",
          save: "Save",
          saving: "Saving...",
          close: "Close",
          cuenta: "Account",
          description: "Description",
          valor: "Value",
          funcional: "Functional",
          alterna: "Alternate",
          seleccionadas: "Selected accounts",
          selectAll: "Select all",
          noAccountsFound: "No accounts found"
        }
      }
    }
  },
  watch: {
    critCuenta() {
      this.buscaCuenta()
    },
    critDescripcion() {
      this.buscaDescripcion()
    },
    listCuentas: {
      immediate: true,
      handler() {
        this.initSelectionState()
      }
    },
    showEdiAjustOrig(val) {
      if (val) {
        this.initSelectionState()
      }
    }
  },
  methods: {
    f_titulo() {
      return this.dataEdit.cuenta ? this.labels.title : "Adición de Cuentas"
    },
    buscaCuenta() {
      let filtradas = []
      if (this.critCuenta.length == 0) {
        filtradas = this.listCuentas
      } else {
        const criterio = "^" + this.critCuenta
        filtradas = this.listCuentas.filter(
          (cuenta) => cuenta.cuenta && cuenta.cuenta.match(criterio)
        )
      }
      this.syncFilteredSelection(filtradas)
    },
    buscaDescripcion() {
      let filtradas = []
      if (this.critDescripcion.length == 0) {
        filtradas = this.listCuentas
      } else {
        filtradas = this.listCuentas.filter(
          (cuenta) => cuenta.descripcion && cuenta.descripcion.toUpperCase().indexOf(this.critDescripcion.toUpperCase()) >= 0
        )
      }
      this.syncFilteredSelection(filtradas)
    },
    initSelectionState() {
      if (!Array.isArray(this.listCuentas)) return

      this.listCuentas.forEach(cuenta => {
        cuenta._selected = this.listadoCuentasOrig.includes(cuenta.cuenta)
      })

      const base = Array.isArray(this.listCuentasSelMul) && this.listCuentasSelMul.length > 0
        ? this.listCuentasSelMul
        : this.listCuentas
      this.syncFilteredSelection(base)
    },
    syncFilteredSelection(cuentas) {
      this.listCuentasSelMul = (cuentas || []).map(cuenta => {
        cuenta._selected = this.listadoCuentasOrig.includes(cuenta.cuenta)
        return cuenta
      })
      this.updateSelectAll()
    },
    toggleSelectAllOrig() {
      this.listCuentasSelMul.forEach(cuenta => {
        cuenta._selected = this.selectAllOrig
        const index = this.listadoCuentasOrig.indexOf(cuenta.cuenta)
        if (this.selectAllOrig && index === -1) {
          this.listadoCuentasOrig.push(cuenta.cuenta)
        }
        if (!this.selectAllOrig && index > -1) {
          this.listadoCuentasOrig.splice(index, 1)
        }
      })
    },
    onAccountChange(cuenta) {
      const index = this.listadoCuentasOrig.indexOf(cuenta.cuenta)
      if (cuenta._selected && index === -1) {
        this.listadoCuentasOrig.push(cuenta.cuenta)
      }
      if (!cuenta._selected && index > -1) {
        this.listadoCuentasOrig.splice(index, 1)
      }
      this.updateSelectAll()
    },
    updateSelectAll() {
      if (!this.listCuentasSelMul || this.listCuentasSelMul.length === 0) {
        this.selectAllOrig = false
        return
      }
      this.selectAllOrig = this.listCuentasSelMul.every(cuenta => cuenta._selected)
    },
    guardaAjuste() {
      if (this.isSaving) return;

      // Validaciones (mantengo las originales)
      if (this.dataEdit.valor === '') {
        this.dataEdit.valor = null
      }
      if (this.dataEdit.funcional === '') {
        this.dataEdit.funcional = null
      }
      if (this.dataEdit.alterna === '') {
        this.dataEdit.alterna = null
      }
      
      if (this.dataEdit.valor != null &&
        (this.dataEdit.funcional === null ||
          this.dataEdit.alterna === null)) {
        this.$toast.error("Funcional y Alterna no pueden ser nulos")
        return
      }

      if (this.dataEdit.valor === null &&
        (this.dataEdit.funcional != null ||
          this.dataEdit.alterna != null)) {
        this.$toast.error("Funcional y Alterna deben ser nulos")
        return
      }

      let form = {}
      if (this.dataEdit.cuenta) {
        form = {
          'id': this.dataEdit.id,
          'cuenta': this.dataEdit.cuenta,
          'vigencia': this.dataEdit.vigencia,
          'companyId': this.dataEdit.id_compania,
          'valor': this.dataEdit.valor,
          'funcional': this.dataEdit.funcional,
          'alterna': this.dataEdit.alterna,
          'secuencia': this.secuencia,
          'idUser': this.$store.state.userId || 1,
        }
      } else {
        form = {
          'vigencia': this.vigencia,
          'secuencia': this.secuencia,
          'codReporte': this.codReporte,
          'companyId': this.idCompania,
          'tipo': this.tipo,
          'tipo_ajuste': this.tipo_ajuste,
          'listadoCuentas': this.listadoCuentasOrig,
          'idUser': this.$store.state.userId,
        }
      }
      
      this.isSaving = true;
      AjustesConsol.updateAjusteOrigen(form)
        .then((res) => {
          if (res.status == 200) {
            this.$toast.success(res.data.message)
          }
        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => {
          setTimeout(() => {
            this.reloadTbl();
            this.isSaving = false;
          }, 2000)
        })
    },
    closeModal() {
      if (this.isSaving) return;
      this.$emit('closeModal', false)
    },
    reloadTbl() {
      let form = {
        'id': this.secuencia,
        'vigencia': this.vigencia,
        'idCompany': this.idCompania
      }
      this.$emit('reloadTblOrig', form)
    }
  },
}
</script>

<style scoped>
.custom-dialog {
  width: 92vw;
  max-width: 1100px;
  min-width: 900px;
  border-radius: 8px;
}

.custom-dialog >>> .md-dialog {
  margin: 0 auto !important;
}

.custom-dialog >>> .md-dialog-container {
  width: 92vw !important;
  max-width: 1100px !important;
  margin: 0 auto !important;
}

.dialog-header {
  background: #34495e;
  color: white;
  padding: 20px 24px;
  border-bottom: 1px solid #2c3e50;
}

.header-title {
  font-size: 1.2rem;
  font-weight: 500;
}

.dialog-content {
  padding: 24px;
}

.search-fields {
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #ecf0f1;
}

.search-inputs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
}

.form-fields {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-field {
  margin-bottom: 0;
}

.field-label {
  display: block;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 8px;
  font-size: 14px;
}

.custom-field {
  margin: 0;
}

.display-value {
  background: #f8f9fa;
  padding: 10px 12px;
  border-radius: 4px;
  border: 1px solid #e9ecef;
  color: #495057;
  font-size: 14px;
  min-height: 40px;
  display: flex;
  align-items: center;
}

.multi-select-container {
  position: relative;
}

.select-all-container {
  margin-bottom: 8px;
}

.accounts-table-container {
  max-height: 260px;
  overflow-y: auto;
  border: 1px solid #bdc3c7;
  border-radius: 4px;
  background: white;
}

.accounts-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.accounts-table th,
.accounts-table td {
  padding: 3px 6px;
  border-bottom: 1px solid #e9ecef;
  text-align: left;
  line-height: 1.1;
  vertical-align: middle;
}

.checkbox-column {
  width: 32px;
}

.account-column {
  width: 120px;
}

.desc-column {
  width: auto;
}

.accounts-table .md-checkbox {
  margin: 0 !important;
}

.accounts-table .md-checkbox .md-checkbox-container {
  width: 14px !important;
  height: 14px !important;
}

.selection-count {
  margin-bottom: 8px;
  font-size: 12px;
  color: #7f8c8d;
  font-style: italic;
}

.no-results {
  font-size: 13px;
  color: #7f8c8d;
  padding: 8px 0;
}

.dialog-actions {
  padding: 16px 24px;
  border-top: 1px solid #ecf0f1;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.cancel-btn {
  background: #95a5a6 !important;
  color: white !important;
}

.save-btn {
  background: #3498db !important;
  color: white !important;
}

@media (max-width: 768px) {
  .custom-dialog {
    min-width: 96vw;
    width: 96vw;
    margin: 10px;
  }

  .custom-dialog >>> .md-dialog-container {
    width: 96vw !important;
  }
  
  .search-inputs {
    grid-template-columns: 1fr;
    gap: 10px;
  }
  
  .dialog-content {
    padding: 20px;
  }
  
  .dialog-actions {
    padding: 12px 20px;
    flex-direction: column;
  }
  
  .cancel-btn,
  .save-btn {
    width: 100%;
  }
}
</style>

<style>
.md-dialog.custom-dialog {
  left: 50% !important;
  transform: translateX(-50%) !important;
  margin: 0 !important;
}

.md-dialog.custom-dialog .md-dialog-container {
  width: 92vw !important;
  max-width: 1100px !important;
  min-width: 900px !important;
  margin: 0 auto !important;
}

@media (max-width: 768px) {
  .md-dialog.custom-dialog .md-dialog-container {
    width: 96vw !important;
    min-width: 96vw !important;
  }
}
</style>
